const doc = [({"da":({"js":({"admin":({"users":({"index":({"the_user_was_deleted":"Brugeren blev slettet"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;